import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loading-div" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "loader" }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "alert-error-router"
}
const _hoisted_6 = { class: "d-flex box-alert__content alert-warning" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons-outlined animated" }, "warning", -1 /* HOISTED */)
const _hoisted_8 = { class: "alert__content-text" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Warning!", -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("footer", null, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_btn_group = _resolveComponent("btn-group")!
  const _component_BtnGroupHistory = _resolveComponent("BtnGroupHistory")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_navbar = _resolveComponent("navbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : _createCommentVNode("v-if", true),
    (_ctx.errorRouterMes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.errorRouterMes), 1 /* TEXT */)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_navbar, null, _createSlots({
      body: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 2 /* DYNAMIC */
    }, [
      (_ctx.isShowBtnGroup)
        ? {
            name: "btn-group",
            fn: _withCtx(() => [
              _createVNode(_component_btn_group)
            ]),
            key: "0"
          }
        : undefined,
      (_ctx.isShowBtnGroupHistory)
        ? {
            name: "btn-group-history",
            fn: _withCtx(() => [
              _createVNode(_component_BtnGroupHistory)
            ]),
            key: "1"
          }
        : undefined
    ]), 1024 /* DYNAMIC_SLOTS */),
    _hoisted_10
  ], 64 /* STABLE_FRAGMENT */))
}